<app-home-main-caption></app-home-main-caption>
<app-home-favourite-content></app-home-favourite-content>
<div class="delimiter"></div>
<app-home-hotspot></app-home-hotspot>
<div class="delimiter"></div>
<app-home-connectivity></app-home-connectivity>
<div class="delimiter"></div>
<app-home-compatibility></app-home-compatibility>
<app-home-plans></app-home-plans>